import { type PropsWithChildren } from 'react';

import { ColorRuleContext } from '../../core/context/ColorRuleContext.js';
import { HoneycombCustomTooltipContext } from '../context/honeycomb-custom-tooltip.context.js';
import { HoneycombLegendConfigContext } from '../context/honeycomb-legend-config.context.js';
import { HoneycombToolbarConfigContext } from '../context/honeycomb-toolbar-config.context.js';
import { HoneycombSlotsConfig } from '../types/honeycomb-internal.js';

export const HoneycombConfigurationProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: HoneycombSlotsConfig }>) => {
  const { legend, toolbar } = config;

  return (
    <HoneycombLegendConfigContext.Provider value={legend}>
      <HoneycombToolbarConfigContext.Provider value={toolbar}>
        <ColorRuleContext.Provider value={config.colorRules}>
          <HoneycombCustomTooltipContext.Provider value={config.tooltip}>
            {children}
          </HoneycombCustomTooltipContext.Provider>
        </ColorRuleContext.Provider>
      </HoneycombToolbarConfigContext.Provider>
    </HoneycombLegendConfigContext.Provider>
  );
};
